<h2 mat-dialog-title>
    {{data?.playlist ? 'Edit Playlist' : 'Create Playlist'}}
</h2>

<mat-dialog-content>

    <form [formGroup]="form" class="mt-2">
        <div class="form-row">
            <mat-form-field appearance="outline" class="name-field me-2">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" placeholder="Enter playlist name">
                <mat-error>
                    @if (form.get('name')?.hasError('required')) {
                    Playlist name is required
                    }
                    @if (form.get('name')?.hasError('minlength')) {
                    Name must be at least 2 characters
                    }
                </mat-error>
            </mat-form-field>
        </div>
    </form>


    <div class="playlist-container">

        <!-- MEDIA LIST -->
        <div class="media-panel">

            <h3>Media</h3>

            <mat-selection-list #mediaSelection>

                @for (media of mediaLibrary; track media.id) {
                <mat-list-option [value]="media">
                    {{ media.name }}
                </mat-list-option>
                }


            </mat-selection-list>

        </div>


        <!-- ACTION BUTTONS -->

        <div class="transfer-buttons">

            <button mat-icon-button color="primary" (click)="addToPlaylist(mediaSelection.selectedOptions.selected)">
                <mat-icon>arrow_forward</mat-icon>
            </button>

        </div>


        <!-- PLAYLIST -->

        <div class="playlist-panel">
            <h3>Playlist</h3>

            @if (playlistStack.length === 0) {
            <div class="empty-playlist">
                <mat-icon>playlist_add</mat-icon>
                <p>Select media from the left panel to build your playlist</p>
            </div>
            }



            <div cdkDropList #playlistList="cdkDropList" [cdkDropListData]="playlistStack" class="playlist-list"
                (cdkDropListDropped)="drop($event)">

                @if (hasInvalidDuration()) {

                <div class="duration float-start pt-2 pe-1">
                    <div class="alert alert-danger" role="alert">
                        Some media items have invalid durations. Please correct them before saving.
                    </div>
                </div>

                }

                @for (media of playlistStack; track media.id; let i = $index) {
                <div class="playlist-item" cdkDrag [cdkDragData]="media">
                    <div class="ribbon">
                        <div class="ribbon-content">
                            <span class="media-name">{{media.name}}</span>

                        </div>

                        <div class="ribbon-controls">
                            <mat-form-field appearance="outline" class="duration-field">
                                <mat-label>Duration</mat-label>

                                <input matInput maxlength="5" [(ngModel)]="media.durationDisplay"
                                    (blur)="updateDuration(media)" placeholder="MM:SS">

                                @if (media.durationError) {
                                <mat-error>
                                    Minimum duration is 5 seconds
                                </mat-error>
                                }

                            </mat-form-field>
                            <mat-form-field appearance="outline" class="fit-select">
                                <mat-label>Fit</mat-label>
                                <mat-select [(ngModel)]="media.fit">
                                    <mat-option value="fit">Fit</mat-option>
                                    <mat-option value="fill">Fill</mat-option>
                                    <mat-option value="stretch">Stretch</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <button mat-icon-button class="remove-btn" (click)="removeMedia(i)">
                                <mat-icon color="warn">delete</mat-icon>
                            </button>
                        </div>

                        <div class="drag-handle">
                            <mat-icon>drag_indicator</mat-icon>
                        </div>
                    </div>
                </div>
                }
            </div>


        </div>


    </div>


    <div class="duration float-end pt-2 pe-1">
        Total Duration: <strong>{{ formatDuration(totalDuration) }}</strong>
    </div>

</mat-dialog-content>


<mat-dialog-actions align="end">

    <button mat-button (click)="dialogRef.close()"><mat-icon>close</mat-icon>Cancel</button>

    <button mat-raised-button color="primary" (click)="save()"
        [disabled]="form.invalid || playlistStack.length === 0 || hasInvalidDuration()">
        <mat-icon>save</mat-icon>
        {{data?.playlist ? 'Update Playlist' : 'Save Playlist'}}
    </button>

</mat-dialog-actions>